<template>
  <div class="w-per100 h400 column flex_center white_color"
  :style="{backgroundImage: 'url('+ bg +')',backgroundSize: '100% 100%',backgroundRepeat: 'no-repeat'}">
    
  </div>
</template>
<script>
import { getCategoryList,getCategoryData } from '@/api/app'
export default {
  data() {
    return {
      bg:''
    }
  },
  props:{
    // title:String,
    current: Number,
  },
  mounted() {
    this.fetchOtherVal()
  },
  methods: {
    async fetchOtherVal() {
      let {data} = await getCategoryList()
      let list = data.data.list;
      // console.log("list", list);
      if(this.current == 1){
        let yx = list.find(item => item.catname === '营销传播');
        this.bg = yx.image
      }else if(this.current == 2){
        let hd = list.find(item => item.catname === '活动策划');
        this.bg = hd.image
      }if(this.current == 3){
        let zh = list.find(item => item.catname === '综合服务');
        this.bg = zh.image
      }if(this.current == 4){
        let gy = list.find(item => item.catname === '关于我们');
        this.bg = gy.image
      }
    },
  },
}
</script>
<style lang="scss">

</style>
